import { useParams } from "react-router-dom";

export const useFunnelSourceCreatePageParams = () => {
  const { siteSlug = "", funnelSlug = "" } = useParams();

  return { siteSlug, funnelSlug };
};
